const COOKIE_PREFIX = 'v1'

export const CLIENT_ID_COOKIE = `${COOKIE_PREFIX}_clientID`
export const FORCED_DECISIONS_COOKIE = `${COOKIE_PREFIX}_forced_decisions_cookie`
